<template>
  <div class='ul_flex' :class="device.isMobile ? 'ul_flex_mobile' : ''">
    <div v-if="content.inputtype" class="inputtype">Information About the Dragon Boat Festival</div>
    <div v-for="(item,index) in content.content" :key="item.key" class="module_div" :style="{
        borderBottom:index==0?'1rem dashed #CADBD4':'',
        padding:item.width?'34rem 15rem 21rem':'34rem 15rem 41rem'
    }">
        <span>{{ item.text }}</span>
        <ul class="ul_text" v-if="item.width">
            <li v-for="(ite,ind) in item.list" :key="ite.key" :style="{
                width:item.width&&item.width==50?item.width+'%':'auto',
                color:ite.color,
                fontSize:ite.size+'rem',
                fontFamily:ite.fontFamily,
                lineHeight:1.2,
                marginBottom:'13rem',
                marginRight:item.width==25?'20rem':''
            }"> 
           
                {{ ite.text }}
                <!-- <inputComponent :key="ite.key+ '.2'"  :content="ite" v-if="!item.width&&ite.category=='input'"></inputComponent> -->
            </li>
        </ul>
        <ul class="ul_text" v-if="!item.width">
            <li v-for="(ite,ind) in item.list" :key="ite.key" :style="{
                width:item.width?item.width+'%':'auto',
                color:ite.color,
                fontSize:ite.size+'rem',
                fontFamily:ite.fontFamily,
            }"><span v-for="(itee,indd) in ite.listitem" :key="itee.key"
                >{{ itee.text }}<inputComponent :key="itee.key+ '.2'"  :content="itee" v-if="itee.category=='input'"></inputComponent></span
              ></li
            >
        </ul>
    </div>
  </div>
</template>
   
<script>
import inputComponent from "../text/input.vue";
export default {
  data(){
    return {

    }
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components:{
    inputComponent
  },
  created() {

  },
  methods: {
  
  },
}
</script>
   
<style scoped lang='scss'>
  .ul_flex{
    width:calc(100% - 48rem);
    background: #F0F8F5;
    border-radius: 10rem;
    margin:30rem  auto 0;
    .module_div{
        padding:34rem 15rem 41rem;
        font-family: Calibri;
        >span{
            color:#5CA683;
            font-size:28rem;
            font-family: Calibri;
            font-weight: bold;
        }
    }
    .ul_text{
        display: flex;
        width:100%;
        flex-wrap: wrap;
        font-size: 24rem;
        li{
          // text-overflow: ellipsis;
          // overflow: hidden;
          // word-break: break-all;
          // white-space: nowrap;
          // padding-right:5rem;
          box-sizing: border-box;
        }
    }
  }
  .inputtype{
    height: 58rem;
    line-height: 58rem;
    text-align: center;
    font-style: italic;
    color:#FFFFFF;
    font-size: 24rem;
    background: #8CB894;
    border-radius:10rem 10rem 0 0 ;
  }
  .ul_flex_mobile{
    .ul_text{
      font-size: 28rem;
    }
  }
</style>